var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 6.0415C10.345 6.0415 10.6248 6.32133 10.6248 6.6665V9.37484H13.3332C13.6783 9.37484 13.9582 9.65466 13.9582 9.99984C13.9582 10.345 13.6783 10.6248 13.3332 10.6248H10.6248V13.3332C10.6248 13.6783 10.345 13.9582 9.99984 13.9582C9.65466 13.9582 9.37484 13.6783 9.37484 13.3332V10.6248H6.6665C6.32133 10.6248 6.0415 10.345 6.0415 9.99984C6.0415 9.65466 6.32133 9.37484 6.6665 9.37484H9.37484V6.6665C9.37484 6.32133 9.65466 6.0415 9.99984 6.0415Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 2.2915C5.74264 2.2915 2.2915 5.74264 2.2915 9.99984C2.2915 14.257 5.74264 17.7082 9.99984 17.7082C14.257 17.7082 17.7082 14.257 17.7082 9.99984C17.7082 5.74264 14.257 2.2915 9.99984 2.2915ZM1.0415 9.99984C1.0415 5.05229 5.05229 1.0415 9.99984 1.0415C14.9474 1.0415 18.9582 5.05229 18.9582 9.99984C18.9582 14.9474 14.9474 18.9582 9.99984 18.9582C5.05229 18.9582 1.0415 14.9474 1.0415 9.99984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleWhite);
export default __webpack_public_path__ + "static/media/add-circle-white.c4d387c65b8490218dce28eebe994797.svg";
export { ForwardRef as ReactComponent };